import mixin from '@/mixins/mixins'

export default {
  SET_DATA (state, data) {
    state.about = mixin.methods.decodeEntities(data[0].tentang)
    state.privacy_policy = mixin.methods.decodeEntities(data[0].kebijakan)
    state.terms_conditions = mixin.methods.decodeEntities(data[0].syarat)
  }
}